import { render, staticRenderFns } from "./Anonimous.vue?vue&type=template&id=c55b8750"
import script from "./Anonimous.vue?vue&type=script&lang=js"
export * from "./Anonimous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports